module.exports = __webpack_public_path__ + "img/tmp-patients-status-2.456b0cee.svg";